import { jsx } from "panel";
export function template() {
  return /* @__PURE__ */ jsx("div", { hook: {
    insert: (node) => this.helpers.onInsertStickyPlaceholder(node)
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" });
}
